import React, { useEffect } from 'react';
import parse from 'html-react-parser';
import { Question, QuestionBasic } from '../../@types/question.interface';
import './question-content.styles.scss';
import DOMPurify from 'dompurify';
import { Answer } from '../../@types/answer.interface';

interface IProps {
    question: Question | QuestionBasic;
    answer?: Answer | null;
    handleChange?: (evt: any, questionType: number) => void;
}

export default function QuestionContent({
    question,
    answer,
    handleChange,
}: IProps) {
    const letters = ['A', 'B', 'C', 'D'];
    useEffect(() => {
        let inputs: any = document.getElementsByClassName('input-answer');
        for (let index = 0; index < inputs.length; index++) {
            if (inputs[index].checked) inputs[index].checked = false;
            if (answer !== null && answer?.student_answer)
                for (
                    let index2 = 0;
                    index2 < answer?.student_answer.length;
                    index2++
                ) {
                    if (
                        inputs[index].value ===
                        answer.student_answer[index2].answer
                    )
                        inputs[index].checked = true;
                }
        }
    }, [question, answer]);
    return (
        <div className="question">
            <div className="question__content">
                <div className="question__content__question">
                    {question.question_quiz !== ''
                        ? parse(DOMPurify.sanitize(question.question_quiz))
                        : 'Question'}
                </div>
                <form className="question__content__choices">
                    {question.question_choice.map((choice, idx) => (
                        <div key={idx}>
                            <span>
                                <input
                                    type={
                                        question.question_type_id === 1
                                            ? 'radio'
                                            : 'checkbox'
                                    }
                                    className="input-answer"
                                    name={'question' + question.question_number}
                                    value={letters[idx]}
                                    onChange={(evt) =>
                                        handleChange
                                            ? handleChange(
                                                  evt,
                                                  question.question_type_id
                                              )
                                            : ''
                                    }
                                />
                            </span>
                            <span>
                                <div>
                                    {parse(DOMPurify.sanitize(choice.answer))}
                                </div>
                            </span>
                        </div>
                    ))}
                </form>
            </div>
        </div>
    );
}
